import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getProviderPlan } from "../slice/providerPanelPlansSlice";
import { loadStripe } from "@stripe/stripe-js";

const stripePromise = loadStripe(process.env.REACT_APP_BACKEND_URL); 

const ProviderRateReview = () => {
  const dispatch = useDispatch();
  const { providersPlan } = useSelector((state) => state.providerPlans);

  const providerToken = localStorage.getItem("provider_access_token");

  useEffect(() => {
    dispatch(getProviderPlan(providerToken));
  }, [dispatch]);

  const handleChoosePlan = async (planId) => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/provider/checkout-session`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${providerToken}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ plan_id: planId }),
      });

      const data = await res.json();
      const stripe = await stripePromise;

      if (data?.sessionId) {
        await stripe.redirectToCheckout({ sessionId: data.sessionId });
      } else {
        console.error("No session ID received from backend");
      }
    } catch (err) {
      console.error("Stripe Checkout error:", err);
    }
  };


  return (
    <>
      <div className="col-md-8 col-xl-9 mt-4 mt-md-0">
        <div className="ps-2 ps-lg-4">
          <h4 className="font-weight-bold text-primary font-size-40 mb-4 pb-1 line-hight-2 border-bottom pb-3 montserrat">
            Provider Plans
          </h4>
          <div className="row g-4">
            {providersPlan?.length > 0 ? (
              providersPlan.map((plan, index) => (
                <div key={index} className="col-md-4">
                  <div
                    className="card shadow-sm rounded h-100"
                    style={{ minHeight: "300px" }} // adjust height here
                  >
                    <div className="card-body text-center d-flex flex-column justify-content-between">
                      <div>
                        <h5 className="card-title text-uppercase font-weight-bold">
                          {plan.plan_title}
                        </h5>
                        <h4 className="text-primary font-weight-bold mt-3">
                            ${parseFloat(plan.price).toFixed(2)}
                        </h4>
                        <h6 className="text-muted mb-3">
                          Duration: {plan.duration} months
                        </h6>
                        <p className="card-text">
                          {plan.description}
                        </p>
                      </div>
                      <div className="d-flex justify-content-center">
                        <button type="button" className="btn btn-lg btn-block btn-custom-primary w-75 rounded" onClick={() => handleChoosePlan(plan.id)}>Choose Plan</button>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-12">
                <p>No provider plans available.</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProviderRateReview;
